import { Injectable } from '@angular/core';
import { AkmfScreenService, AkmfSpinnerAnimationService } from '@akmf/ng-shared';
import { TranslateService } from '@ngx-translate/core';
import { AppConfigService } from './app-config.service';

@Injectable({ providedIn: 'root' })
export class AppInitializerService {
  constructor(
    private translate: TranslateService,
    private screenService: AkmfScreenService,
    private appConfigService: AppConfigService,
    private spinnerAnimationService: AkmfSpinnerAnimationService,
  ) {}

  initApp(): void {
    this.screenService.initScreenService();
    this.initAppLanguage();
    this.spinnerAnimationService.initSpinnerAnimation({ loading: 'common.loading' });
  }

  private initAppLanguage(): void {
    const appLangs = this.appConfigService.supportedLangs ?? ['pl'];
    this.translate.addLangs(appLangs);
    const browserLang = this.translate.getBrowserLang();
    const defaultLang = appLangs.some((lang) => browserLang === lang) ? browserLang : 'pl';
    this.translate.onLangChange.subscribe(({ lang }) => {
      document.documentElement.setAttribute('lang', lang);
    });
    this.translate.setDefaultLang(defaultLang);
    this.translate.use(defaultLang);
  }
}
